import React from "react";

import styles from "./Modal.module.scss";

interface Props {
    text?: string,
    openModal: (arg: boolean) => void,
    children?: React.ReactNode
}

const Modal: React.FC<Props> = ({ children, text, openModal }) => {

    return (
        <div className={styles.modalContainer}>
            <div className={styles.modalBox}>
                <div className={styles.closeBox}>
                    <div className={styles.closeBtn} onClick={() => openModal(false)}></div>
                </div>
                {text && (
                    <p className={styles.modalText}>
                        {text}
                    </p>
                )
                }
                {children}
                {/* <button className={styles.modalBtn} onClick={() => openModal(false)}>OK</button> */}
            </div>
        </div>
    )
}

export default Modal;